/**
 * @module      public/js/services/dialers/baseDialer.js
 * @summary     Abstract “Dialer” interface (provider-agnostic).
 *
 * @description
 *  Every concrete dialer **must** extend this class and implement:
 *    • `async call({ to, contactId, userId })`
 *  The UI layer and other services rely on that single contract, keeping
 *  them decoupled from any provider-specific code (Twilio, Vonage …).
 *
 * @author      Auto-Generated
 * @version     1.0.0
 * @since       2025-05-01
 */

export default class BaseDialer {
  /** @param {Object} opts – provider-specific config/creds */
  constructor(opts = {}) {
    this.opts = opts;
  }

  /**
   * Dial the given phone number.
   * @param  {Object} args
   * @param  {string} args.to        – E.164 phone number
   * @param  {string} [args.contactId]
   * @param  {string} [args.userId]
   * @returns {Promise<void>}
   */
  /* eslint-disable class-methods-use-this */
  async call(/* args */) {
    throw new Error('BaseDialer.call() must be overridden');
  }
}
